// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/Components/Traduction.css
// module id = 8282
// module chunks = 2